import React from 'react';
import cx from 'classnames';

import {  Col } from 'react-bootstrap';
import styles from '../../FliteviewSettingsView.module.scss';

import TinymceEditor from './editor';
import { localizedStrings } from '../../../../../../localization';
class ReshareEmail extends React.Component {
    constructor(props) {
        super(props);

    this.localizedSettings = localizedStrings.pages.settings;
    this.localizedViewerSettings = this.localizedSettings.account.viewer_settings;
    }

  render() {
    return (
        <Col md={12} className={cx(styles.textEditor, styles.column)}>
            <div className={styles.title}>{this.props.title}</div>
            <div className={styles.description}>{this.props.description}</div>
            <div className={styles.header}>{this.localizedViewerSettings.library_settings.email_content.email_content}</div>
            <TinymceEditor content={this.props.text} onChange={(content) => this.props.onContentChange({'reshareEmail': content})} height={280}/>
        </Col>
    );
  }
}

export default ReshareEmail;